module.exports = __webpack_public_path__ + "static/media/Pe-icon-7-stroke.71394c0c.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/styles/icons/pe-icon-7-stroke/fonts/Pe-icon-7-stroke.eot
 ** module id = 1604
 ** module chunks = 0
 **/